import _ from 'lodash';
import PropTypes from 'prop-types';


import useResponsive from '../../../utils/responsive';
import { Image, Shapes, Hover } from '../shared';


const iff = (condition, then, otherwise) => {
    return condition ? then : otherwise;
};

const PartnersSection = (props) => {
    const { title, paragraph, imgSrc, imgAlt, icons } = props;       
    const { isSmallTablet, isLargeTablet, isMobile, isTablet } = useResponsive();
    const isSmallScreen = isMobile || isTablet;

    const renderImageSection = () => {
        return (

            <div id="main" style={{ position: 'relative' }}>

                {isSmallScreen && (
                    <div>
                        <h2 className='partners-section-heading'>{title}</h2>
                        <p className='partners-section-paragraph'>{paragraph}</p>
                    </div>
                )}

                <Hover imgSrc={imgSrc} imgAlt={imgAlt} />

                <div className='partners-section-shape-container'>
                    <Shapes
                        isPair
                        isDark
                        speed={isMobile ? 0.15 : 0.2}
                        containerMargins={{
                            left: iff(
                                isMobile,
                                '85%',
                                iff(
                                    isSmallTablet,
                                    '70%',
                                    iff(isTablet, '72%', iff(isLargeTablet, '75%', '85%')),
                                ),
                            ),
                            top: isMobile ? '-80%' : '-100%',
                        }}
                        degrees="-38.66deg"
                        smallMargins={{
                            width: isMobile ? 17.18 : 50,
                            height: isMobile ? 8.59 : 23,
                        }}
                        largeMargins={{
                            width: isMobile ? 29.56 : 86,
                            height: isMobile ? 14.78 : 43,
                        }}
                        distanceBetween={{ width: '0%', height: '25%' }}
                        zIndex={1}
                    />
                </div>

            </div>
        );
    };

    const renderTextSection = () => {
        return (
            <div>
                {!isSmallScreen && (
                    <div>
                        <h2 className='partners-section-heading'>{title}</h2>
                        <p className='partners-section-paragraph'>{paragraph}</p>
                    </div>
                )}
                {renderIcons()}
            </div>
        );
    };

    const renderIcons = () => {
        return icons.map((icon, index) => {
            const iconSrc = _.get(icon, 'icon_image.url');
            const iconTitle = _.get(icon, 'icon_title');
            const iconParagraph = _.get(icon, 'icon_paragraph');
            return (
                <div key={index} className='partners-section-icon-and-text-container'>
                    <div className='partners-section-icon-container'>
                        <Image src={iconSrc} alt="" isOldImage />
                    </div>
                    <div>
                        <h5>{iconTitle}</h5>
                        <p className='partners-section-icon-paragraph'>{iconParagraph}</p>
                    </div>
                </div>
            );
        });
    };

    return (
        <div className='container-root container-root-maxWidthLg'>

            <div className='main-grid-container main-grid-spacing-xs-3 partners-section-grid-container'>

                <div className='main-grid-item main-grid-lg-6 main-adjust-width-grid'>
                    <div className='partners-section-image-container'>{renderImageSection()}</div>
                </div>

                <div className='main-grid-item main-grid-lg-5'>
                    {renderTextSection()}
                </div>

            </div>

        </div>
    );
};

export default PartnersSection;

PartnersSection.propTypes = {
    isMobile: PropTypes.bool,
    isTablet: PropTypes.bool,
    title: PropTypes.string,
    paragraph: PropTypes.string,
    imgSrc: PropTypes.string,
    imgAlt: PropTypes.string,
    icons: PropTypes.array,
};
